<div class="inventory-modal"> 
  <div class="inventory-modal__header">
    <span *ngIf="systemId==1 || systemId==3" class="inventory-modal__title">{{'Start New Undercarriage Rebuild Center' | translate | async}} </span>
    <span *ngIf="systemId==2" class="inventory-modal__title">{{'Select New Idler Rebuild & Select a Frame ' | translate | async}} </span>

     <i class="material-icons inventory-modal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <div class="center" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
  </div>
  <div *ngIf="!isLoading" class="inventory-modal__body">


  <div class="flex-horizontal set-margin">
    
    <mat-form-field *ngIf="systemId==1">
      <!-- <mat-select  placeholder="Select a Chain"  [(ngModel)]="selected_chain" (selectionChange)="selectChain()">
        <mat-option *ngFor="let system of componentList" [value]="system.EqunitId">
          {{system.Name}}
        </mat-option>
      </mat-select> -->
      <input  matInput [readonly]="true"  placeholder="{{ 'Selected Chain' | translate | async }}" [(ngModel)]="selected_chain.SerialNumber">

    </mat-form-field>

    <mat-form-field *ngIf="systemId==2">
      
      <mat-select  placeholder="Select a Idler"  [(ngModel)]="selected_idler" (selectionChange)="selectIdler()">
        <mat-option *ngFor="let system of componentList" [value]="system.EqunitId">
          {{system.Name}} {{system.Pos}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="systemId==3" >
      <input matInput placeholder="{{ 'Selected Chain' | translate | async }}" [(ngModel)]="selected_chain_Name">
    </mat-form-field>
    
    <mat-form-field >
      <input matInput  #start_Date="ngModel" 
      [(ngModel)]="selected_date" [matDatepicker]="picker" placeholder="Choose a date">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    
    <mat-form-field class="input-full-width">
      <input matInput placeholder="{{ 'Customer Reference' | translate | async }}" [(ngModel)]="selected_customerRef">
    </mat-form-field>

  </div>

  <div class="flex-horizontal set-margin">
    
    <mat-form-field class="input-full-width">
      <input matInput placeholder="{{ 'Job Number' | translate | async }}" [(ngModel)]="selected_jobNumber">
    </mat-form-field>

    <mat-form-field class="input-full-width ">
      <input matInput placeholder="{{ 'Old Job No.' | translate | async }}" [(ngModel)]="selected_oldJobNo">
    </mat-form-field>

    <mat-form-field *ngIf="systemId==1 || systemId==3" class="input-half-width ">
      <input matInput type="number" placeholder="{{ 'Number of Links' | translate | async }}" [(ngModel)]="selected_numOfLinks">
    </mat-form-field>
    
  </div>

  

  
</div>
<div *ngIf="!isLoading" class="item-align-end">

  <div style="align-self: center;margin-right: 20px;" *ngIf="showErrorMessage">
    <span style="color:red;align-self: center;">An error has occurred.Check your details and Try again.</span>
  </div>

  <button mat-raised-button color="warn" (click)="onClickStartInspection()">{{'Start Inspection' | translate | async}}</button>

</div>

</div>